import request from '@/utils/request';
import { BasicListItemDataType } from './data.d';

interface ParamsType extends Partial<BasicListItemDataType> {
  count?: number;
}

export async function queryRooms(params: ParamsType) {
  return request('/api/rooms', {
    params,
  });
}

export async function removeRooms(params: ParamsType) {
  const { count = 5, ...restParams } = params;
  return request('/api/rooms', {
    method: 'POST',
    params: {
      count,
    },
    data: {
      ...restParams,
      method: 'delete',
    },
  });
}

export async function addRooms(params: ParamsType) {
  return request('/api/rooms', {
    method: 'POST',
    data: {
      ...params,
      method: 'post',
    },
  });
}

export async function updateRooms(params: ParamsType) {
  const { id, ...restParams } = params;
  return request(`/api/rooms/${id}`, {
    method: 'POST',
    data: {
      ...restParams,
      method: 'update',
    },
  });
}

export async function queryHosts(params: ParamsType) {
  return request('/api/hostIds', {
    params,
  });
}
